import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { ICommunity } from '../model/community.model';

@Injectable()
export class CommunityService {
    private http = inject(HttpClient);
    private authService = inject(AuthenticationService);

    getCommunities(): Observable<ICommunity[]> {
        const token = this.authService.getUserToken();
        if (!this.hasValidToken(token)) {
            return of();
        }

        return this.http.get<ICommunity[]>(`${environment.API_URL}/api/Community`, this.getAuthOptions(token));
    }

    getCommunity(id: string | undefined): Observable<ICommunity> {
        const token = this.authService.getUserToken();
        if (!this.hasValidToken(token) || !id) {
            return of();
        }

        return this.http.get<ICommunity>(`${environment.API_URL}/api/Community/${id}`, this.getAuthOptions(token));
    }

    upsertCommunity(community: ICommunity): Observable<ICommunity> {
        const token = this.authService.getUserToken();
        if (!this.hasValidToken(token)) {
            return of();
        }

        const payload: ICommunity = {
            id: community.id ?? undefined,
            name: (community.name ?? '').trim(),
            subscriptionId: community.subscriptionId ?? null,
            members: community.members ?? []
        };

        return this.http.post<ICommunity>(`${environment.API_URL}/api/Community/upsert`, payload, this.getAuthOptions(token));
    }

    deleteCommunity(id: string): Observable<ICommunity> {
        const token = this.authService.getUserToken();
        if (!this.hasValidToken(token)) {
            return of();
        }

        return this.http.post<ICommunity>(`${environment.API_URL}/api/Community/delete/${id}`, {}, this.getAuthOptions(token));
    }

    private getAuthOptions(token: string): { headers: HttpHeaders } {
        return {
            headers: new HttpHeaders({
                'Content-type': 'application/json',
                Authorization: `Bearer ${token}`
            })
        };
    }

    private hasValidToken(token: string | null): token is string {
        return token !== undefined && token !== null && token !== '';
    }
}
